<template>
  <v-layout>
    <v-main :class="containerState">
      <v-container id="main-container" class="pb-0" :fluid="true">
        <AppBar />

        <v-card class="d-flex flex-column fill-height" flat>
          <v-card-item>
            <v-card-title>{{ $t("labels.page-section") }}</v-card-title>
          </v-card-item>

          <v-card-text class="flex-grow-1">
            <v-row class="ma-4 align-center" no-gutters>
              <v-col cols="auto">
                <v-select
                  v-model="selectedStandards"
                  :items="availableStandards"
                  item-title="text"
                  item-value="value"
                  :label="$t('labels.select-standards')"
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  style="width: 300px"
                  :readonly="!hasPermission"
                  chips
                  multiple
                />
              </v-col>

              <v-col cols="auto">
                <v-btn
                  variant="outlined"
                  class="bg-secondary ml-3"
                  color="white"
                  :disabled="
                    !hasPermission ||
                    disabledButtonExport ||
                    selectedStandards?.length == 0
                  "
                  @click="postExportModel"
                >
                  {{ $t("labels.export") }}
                </v-btn>
              </v-col>
            </v-row>

            <v-row fill-height>
              <v-col cols="9">
                <StandardOutputVisualization
                  :exportModels="exportModels"
                  :selectedStandards="selectedStandardsDispaly"
                  @changedDisplayStandard="changedDisplayStandard"
                ></StandardOutputVisualization>
              </v-col>
              <v-col cols="3">
                <StandardOutputValidation
                  :validations="validationExportModel"
                ></StandardOutputValidation>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-btn color="secondary" variant="outlined" @click="abortModel">
              {{ $t("labels.cancel") }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              variant="outlined"
              class="bg-secondary"
              color="white"
              @click="routeTo('/editor/data')"
            >
              {{ $t("labels.back") }}
            </v-btn>
            <v-btn
              variant="outlined"
              class="bg-secondary"
              color="white"
              @click="routeTo('/editor/summary')"
            >
              {{ $t("labels.continue") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-main>
    <!--Snackbar-->
    <v-snackbar v-model="snackbar" top color="green" timeout="5000">
      {{ snackbarText }}
      <template v-slot:actions="{ attrs }">
        <v-btn
          color="white"
          variant="text"
          v-bind="attrs"
          @click="snackbar = false"
        >
          OK
        </v-btn>
      </template>
    </v-snackbar>
  </v-layout>
</template>

<script>
import AppBar from "./components/AppBar.vue";
import StandardOutputVisualization from "./components/StandardOutputVisualization.vue";
import StandardOutputValidation from "./components/StandardOutputValidation.vue";
import version from "../version";
import events from "@/mixins/events.js";
import utils from "@/mixins/utils.js";
import AppMixin from "@/mixins/AppMixin.js";
import permissions from "@/mixins/permissions.js";

export default {
  name: "DigitalTwinsConversion",
  components: {
    AppBar,
    StandardOutputVisualization,
    StandardOutputValidation,
  },
  mixins: [utils, events, AppMixin, permissions],
  props: [
    "digitalTwinModelConversionConfig",
    "digitalTwinCommonConfig",
    "realm",
  ],
  data() {
    return {
      appVersion: version,
      containerState: "expanded",
      modelDT: JSON.parse(sessionStorage.getItem("digital-twin-model")),
      snackbar: false,
      snackbarText: "",
      selectedStandards: [],
      selectedStandardsDispaly: [],
      availableStandards: [
        {
          text: "DTDL",
          value: "dtdl",
        },
        {
          text: "NGSI-LD",
          value: "ngsild",
        },
      ],
      exportModels: undefined,
      validationExportModel: undefined,
      disabledButtonExport: false,
    };
  },
  created() {
    if (!this?.modelDT?.modelId) {
      this.abortModel();
      return;
    }

    if (this?.modelDT?.standards?.length > 0) {
      this.selectedStandards = this.modelDT.standards;
      this.selectedStandardsDispaly = this.availableStandards.filter((e) =>
        this.selectedStandards.includes(e.value),
      );
      this.getExportModel();
    }
  },
  mounted() {
    document.addEventListener(
      "language-localstorage-changed",
      this.languageLocalstorageChanged,
    );

    this.containerState =
      localStorage.getItem("sidenav") === "opened" ? "reduced" : "expanded";

    document.addEventListener("sidenav-localstorage-changed", (event) => {
      this.containerState =
        event.detail.storage === "opened" ? "reduced" : "expanded";
    });
  },
  beforeUnmount() {
    document.removeEventListener(
      "language-localstorage-changed",
      this.languageLocalstorageChanged,
    );
  },
  watch: {
    selectedStandards() {
      this.disabledButtonExport = false;
    },
  },
  computed: {},
  methods: {
    languageLocalstorageChanged(event) {
      this.setLocale(event.detail.storage);
    },
    changedDisplayStandard(newVal) {
      this.clearValidationExportModel();

      if (newVal) {
        this.addValidationExportModel({
          type: "success",
          title: this.$t("strings.validation-title-success"),
          description: this.$t(
            "strings.validation-description-success." + newVal,
          ),
        });
      }

      if (this?.exportModels?.[newVal]?.obsolete) {
        this.addValidationExportModel({
          type: "warning",
          title: this.$t("strings.validation-title-warning"),
          description: this.$t("strings.validation-description-warning"),
        });
      }
    },
  },
};
</script>

<style scoped>
main.expanded {
  margin-left: 56px;
}
main.expanded header#upp-bar {
  margin-left: 56px;
  width: calc(100% - 56px) !important;
}
main.reduced {
  margin-left: 256px;
}
main.reduced header#upp-bar {
  margin-left: 256px;
  width: calc(100% - 256px) !important;
}

#main-container {
  height: calc(100vh - 104px);
  overflow-y: auto;
  background-color: white;
}
main.expanded #main-container {
  width: calc(100vw - 56px);
}
main.reduced #main-container {
  width: calc(100vw - 256px);
}
</style>
